import { get } from 'lodash-es';
import { PUB_STATES_LOWERCASE } from 'client/constants/pub-states';

export const isIncentivesWizardActive = ({ inventoryData, pagePublicationState, engineTypes }) => {
  const make = get(inventoryData, 'attributes.vehicle.make.name', '');
  const model = get(inventoryData, 'attributes.vehicle.model.name', '');
  const evEligible = inventoryData?.inventories?.results?.some(i => i.incentives?.isEvEligible);

  return !!(
    evEligible &&
    make &&
    model &&
    [PUB_STATES_LOWERCASE.USED, PUB_STATES_LOWERCASE.NEW].includes(pagePublicationState) &&
    engineTypes.length
  );
};

export const getSupportedWizardEngineTypes = (selectedFacets, inventoryData) => {
  const engineTypes =
    get(selectedFacets, 'engineType') ||
    Array.from(
      new Set(
        get(inventoryData, 'inventories.results', []).map(inventory =>
          get(inventory, 'vehicleInfo.partsInfo.engineType', '')
        )
      )
    );

  return engineTypes.filter(engineType => ['electric', 'plug-in hybrid'].includes(engineType));
};
